import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useState } from 'react';
import _get from 'lodash/get';
import { FORM_ERROR_KEY, FORM_SUCCESS_KEY, UNKNOWN_ERROR_MESSAGE, MESSAGE_TIMEOUT, CHECKED_KEY, DEFAULT_FORM_FIELDS, CONTACT_OPT_IN_KEY } from './DynamicForm.constants';
import { createInitialState, isFormValid, areAllRequiredFieldsFilled, validateFields, getLocationId } from './DynamicForm.utils';
import { DynamicFormAlert, DynamicFormHeader, DynamicFormSubmitButton, DynamicFormBody } from './components';
import { DynamicFormContextProvider } from './context/DynamicFormContext';
import ReCaptchaForm from '../../../../components/RecaptchaForm';
import { ActionName } from '../../../../components/RecaptchaProvider/RecaptchaProvider.constants';
import { GoogleAnalytics } from '../../../../services/analytics';
import { sendDynamicFormEmail } from '../../../../utils/api';
import { classNames } from '../../../../utils/classname';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../../analytics/components/Event';
import { DynamicFormPropType } from '../../types/DynamicForm.types';
import './DynamicForm.less';
var defaultProps = {
  locations: [],
  fields: DEFAULT_FORM_FIELDS,
  onSubmit: sendDynamicFormEmail,
  onSubmitSuccess: null,
  onSubmitError: null,
  submitButtonProps: {
    label: 'Submit',
    fluid: false
  },
  className: '',
  header: '',
  hideLabels: false,
  terms: '',
  successMessage: 'Successfully sent!',
  event: null,
  recaptchaAction: ActionName.WEBSITE_EVENT,
  consentSettings: {
    show: true,
    required: false
  },
  hideRecaptchaNotice: false
};
function DynamicForm(_ref) {
  var businessInfoId = _ref.businessInfoId,
    locationIdProp = _ref.locationId,
    websiteId = _ref.websiteId,
    componentConfigurationId = _ref.componentConfigurationId,
    locations = _ref.locations,
    fields = _ref.fields,
    onSubmit = _ref.onSubmit,
    onSubmitSuccess = _ref.onSubmitSuccess,
    onSubmitError = _ref.onSubmitError,
    successMessage = _ref.successMessage,
    recaptchaAction = _ref.recaptchaAction,
    terms = _ref.terms,
    submitButtonProps = _ref.submitButtonProps,
    className = _ref.className,
    header = _ref.header,
    hideLabels = _ref.hideLabels,
    event = _ref.event,
    consentSettings = _ref.consentSettings,
    hideRecaptchaNotice = _ref.hideRecaptchaNotice;
  var _useState = useState(createInitialState(fields, {
      terms: terms
    })),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    formErrors = _useState4[0],
    setFormErrors = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    touched = _useState8[0],
    setTouched = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isFormDisabled = _useState10[0],
    setIsFormDisabled = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    displayErrors = _useState12[0],
    setDisplayErrors = _useState12[1];
  var _useState13 = useState({
      type: '',
      message: ''
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    notification = _useState14[0],
    setNotification = _useState14[1];
  function clearNotification() {
    setNotification({
      type: '',
      message: ''
    });
  }
  function setFormNotification(message) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FORM_ERROR_KEY;
    setNotification({
      type: type,
      message: message
    });
    setTimeout(function () {
      return clearNotification();
    }, MESSAGE_TIMEOUT);
  }
  function onChange(e, field) {
    if (!touched) {
      var category = _get(event, 'category', EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY);
      GoogleAnalytics.event({
        category: category,
        action: EVENT_ACTIONS.CONTACT_FILL_FORM_EVENT_ACTION
      });
    }
    setTouched(true);
    var name = field.name;
    if (CHECKED_KEY in field) {
      setFormData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, field.checked));
      });
      return;
    }
    setFormData(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, field.value));
    });
  }
  function clearFieldError(name) {
    setFormErrors(function (prevState) {
      var newState = _objectSpread({}, prevState);
      delete newState[name];
      return newState;
    });
  }
  function clearFormErrors() {
    setFormErrors({});
  }
  function initializeFormData() {
    setFormData(createInitialState(fields, {
      terms: terms
    }));
    clearFormErrors();
    setIsFormDisabled(false);
    setDisplayErrors(false);
    setTouched(false);
  }
  function resetFormData() {
    setFormData(createInitialState(fields, {
      terms: terms
    }));
    setFormData(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, CONTACT_OPT_IN_KEY, false));
    });
    setDisplayErrors(false);
  }
  function validateAllFields() {
    var errors = validateFields(fields, formData, consentSettings);
    var updatedErrors = _objectSpread(_objectSpread({}, formErrors), errors);
    setFormErrors(updatedErrors);
    return updatedErrors;
  }
  function handleSubmit(_x, _x2) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, recaptchaToken) {
      var errors, isValid, locationId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            errors = validateAllFields();
            isValid = isFormValid(fields, formData, errors);
            if (isValid) {
              _context.next = 5;
              break;
            }
            setDisplayErrors(true);
            return _context.abrupt("return");
          case 5:
            locationId = getLocationId(locationIdProp, fields, formData, locations);
            _context.prev = 6;
            setLoading(true);
            _context.next = 10;
            return onSubmit({
              businessInfoId: businessInfoId,
              websiteId: websiteId,
              locationId: locationId,
              recaptchaToken: recaptchaToken,
              recaptchaAction: recaptchaAction,
              componentConfigurationId: componentConfigurationId,
              formData: formData
            });
          case 10:
            setIsFormDisabled(true);
            resetFormData();
            setFormNotification(successMessage, FORM_SUCCESS_KEY);
            if (onSubmitSuccess) {
              onSubmitSuccess({
                formData: formData
              });
            }
            _context.next = 20;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](6);
            if (onSubmitError) {
              onSubmitError(_context.t0);
            }
            setFormNotification(UNKNOWN_ERROR_MESSAGE, FORM_ERROR_KEY);
          case 20:
            _context.prev = 20;
            setLoading(false);
            return _context.finish(20);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 16, 20, 23]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  var dynamicFormContextValue = {
    locations: locations,
    componentConfigurationId: componentConfigurationId,
    formData: formData,
    fields: fields,
    isFormDisabled: isFormDisabled,
    event: event,
    hideLabels: hideLabels,
    consentSettings: consentSettings,
    submitButtonProps: submitButtonProps,
    header: header,
    formErrors: formErrors,
    notification: notification,
    terms: terms,
    displayErrors: displayErrors,
    loading: loading,
    initializeFormData: initializeFormData,
    onChange: onChange,
    setFormErrors: setFormErrors,
    clearFieldError: clearFieldError,
    isFormValid: isFormValid(fields, formData, formErrors),
    areAllRequiredFieldsFilled: areAllRequiredFieldsFilled(fields, formData),
    touched: touched
  };
  var finalClassName = classNames(_defineProperty({
    'dynamic-form': true
  }, className, true));
  return /*#__PURE__*/React.createElement("div", {
    className: finalClassName
  }, /*#__PURE__*/React.createElement(DynamicFormContextProvider, {
    value: dynamicFormContextValue
  }, /*#__PURE__*/React.createElement(ReCaptchaForm, {
    loading: loading,
    onSubmit: handleSubmit,
    success: isFormDisabled,
    error: !isFormDisabled,
    action: recaptchaAction,
    hideRecaptchaNotice: hideRecaptchaNotice
  }, /*#__PURE__*/React.createElement(DynamicFormHeader, null), /*#__PURE__*/React.createElement(DynamicFormBody, null), /*#__PURE__*/React.createElement(DynamicFormAlert, null), /*#__PURE__*/React.createElement(DynamicFormSubmitButton, null))));
}
DynamicForm.defaultProps = defaultProps;
export default DynamicForm;